import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { branch, compose, lifecycle, renderNothing, withHandlers, withProps, withStateHandlers } from 'recompose'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookModels from 'app/modules/playbook/models'
import * as EmbedSelectors from 'app/modules/embed/selectors'
import * as UserSelectors from 'app/modules/user/selectors'
import * as PropertyActions from 'app/modules/user/properties/actions'
import * as PropertySelectors from 'app/modules/user/properties/selectors'
import * as IntegrationsSelectors from 'app/modules/integrations/selectors'

import WelcomeMessage from './component'
import { isNil } from 'ramda'

import { getVideoWelcomeMessageCutover } from 'app/modules/access/api'
import { getIframelyVideoEmbed } from 'app/modules/conversation/api'

const usersWithExtension = PropertySelectors.makeUsersWithProperty('extensionInstalled')

const mapStateToProps = state => ({
  theme: EmbedSelectors.theme(state),
  orgUsers: UserSelectors.randomAndOrgUsersAlphabetical(state),
  welcomeMessage: PlaybookSelectors.welcomeMessage(state),
  isOutboundPlaybook: PlaybookSelectors.isOutboundPlaybook(state),
  isABMPlaybook: PlaybookSelectors.isABMPlaybook(state),
  usersWithExtension: usersWithExtension(state),
  isOutreachConnected: IntegrationsSelectors.isConnectedTo(state, 'outreach')
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setMessage: PlaybookActions.setMessage,
      setVideoUrl: PlaybookActions.setVideoUrl,
      setAuthorId: PlaybookActions.setAuthorId,
      fetchUsersByPropertyName: PropertyActions.fetchUsersByPropertyName,
      showExtensionInviteModal: PlaybookActions.showExtensionInviteModal,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(({ theme, orgUsers }) => !theme || !orgUsers.size, renderNothing),
  withStateHandlers(
    (props) => ({
      videoUrlInput: !isNil(props.welcomeMessage.videoUrl) ? props.welcomeMessage.videoUrl : '',
      videoEmbed: null,
      videoCutoverStatus: null
    }),
    {
      setVideoUrlInput: () => (videoUrlInput) => ({
        videoUrlInput
      }),
      setVideoEmbed: () => videoEmbed => ({
        videoEmbed
      }),
      setVideoCutoverStatus: () => videoCutoverStatus => ({
        videoCutoverStatus
      })
    }
  ),
  lifecycle({
    async componentDidMount() {
      if (this.props.isOutboundPlaybook) {
        this.props.actions.fetchUsersByPropertyName(['extensionInvited', 'extensionInstalled'])
      }

      if (isNil(this.props.videoCutoverStatus)) {
        try {
          await getVideoWelcomeMessageCutover()
            .then(data => {
              this.props.setVideoCutoverStatus(data.VIDEO_WELCOME_MESSAGE)
            })
        }
        catch(e) {
          console.warn('Failed to fetch cutover status')
        }
      }

      // fetch the initial embed if it already exists within the playbook
      if (!isNil(this.props.welcomeMessage.videoUrl)) {
        try {
          await getIframelyVideoEmbed(this.props.welcomeMessage.videoUrl)
            .then((data) => {
              this.props.setVideoEmbed(!isNil(data.embed) ? data.embed : null)
            })
        }
        catch(e) {
          console.warn(`Failed to fetch embed for ${this.props.welcomeMessage.videoUrl}`)
        }
      }
    }
  }),
  withProps(props => ({
    userObjForAuthor: props.orgUsers.find(user => user.id === props.welcomeMessage.authorId),
  })),
  withProps(props => ({
    foregroundColor: props.theme.get('foregroundColor'),
    backgroundColor: props.theme.get('backgroundColor'),
    message: props.welcomeMessage.message,
    videoUrl: props.welcomeMessage.videoUrl,
    cta: PlaybookModels.Cta(props.welcomeMessage.cta),
    selectedUser: props.userObjForAuthor,
  })),
  withHandlers({
    onMessageChange: props => message => {
      props.actions.setMessage(message)
    },
    onUserIdChange: props => (option) => {
      option && props.actions.setAuthorId(option.value)
    },
  })
)(WelcomeMessage)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/WelcomeMessage/index.js